import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'

const BaseUrl = '/BizTaskReport'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: true,
    timeout: 10000
  })
/**
 * @param {*} params
 */

export function editTaskReport(params) {
    return request({
        url: `${BaseUrl}/updateState`,
        method: 'put',
        data: params
    })
}

/**
 * 查看详情
 */
export function getTaskReportById(id) {
    return request({
        url: `${BaseUrl}/${id}`,
        method: 'get'
    })
}
// 首页接口
export function getTaskReport(params) {
    return request({
        url: '/homeV2',
        method: 'get',
        params
    })
}
// 汇报接口
export function TaskReport(data) {
    return request({
        url: '/BizTaskReport/saveV2',
        method: 'post',
        data
    })
}
// 汇报详情接口
export function TaskReportDetail(id) {
    return request({
        url: '/BizTaskReport/' + id,
        method: 'get',
    })
}
// 汇报修改
export function TaskReportUpdate(params) {
    return request({
        url: '/BizTaskReport/updateV2',
        method: 'put',
        data: params
    })
}

// 转交提交
export function taskcareSubmit(params) {
    return request({
        url: '/bizTaskDecomposition/taskCareOf',
        method: 'post',
        data: params
    })
}

// 转交权限判断
export function taskCareOfApply(params) {
    return request({
        url: '/bizTaskDecomposition/taskCareOfApply',
        method: 'get',
        params
    })
}

export function exportExcel(startTime, endTime, customerId, projectNumber) {
    service({
      method: 'post',
      url: '/BizTaskReport/export',
      params: {
        startTime: startTime,
        endTime: endTime,
        customerId: customerId,
        projectNumber: projectNumber
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      responseType: 'blob'
    }).then(response => {
        const fileName = startTime + '-' + endTime + `有效人天导出.xlsx`
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = fileName
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
    }).catch(error => {
        console.log(error)
    })
  }
  export function exportDataExcel(startTime, endTime, customerId, projectNumber) {
    service({
      method: 'post',
      url: '/taskVerify/staticsExport',
      params: {
        startTime: startTime,
        endTime: endTime,
        customerId: customerId,
        projectNumber: projectNumber
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      responseType: 'blob'
    }).then(response => {
        const fileName = `有效人天差异统计.xls`
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = fileName
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
    }).catch(error => {
        console.log(error)
    })
  }
  export function exportProjectDataExcel(startTime, endTime, customerId, projectNumber) {
    service({
      method: 'post',
      url: '/taskVerify/staticsProjectExport',
      params: {
        startTime: startTime,
        endTime: endTime,
        customerId: customerId,
        projectNumber: projectNumber
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      responseType: 'blob'
    }).then(response => {
        const fileName = `项目总览报表.xls`
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = fileName
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
    }).catch(error => {
        console.log(error)
    })
  }
